<style scoped>
	.text-default {
		font-size: 10pt;
		font-family: Arial, Helvetica, sans-serif;
	}
	.playground-row {
		border-bottom: solid 2px;
		margin-top: 6px;
		padding-top: 3px;
		padding-bottom: 3px;
	}
	.row-title {
		font-weight: bold;
		font-size: 11pt;
		border-bottom: solid 3px blue;
		margin-top: 3px;
	}
	.control-title {
		font-weight: bold;
	}
	.playground-split-left {
		border-right: dashed 2px blue;
		border-bottom: solid 3px blue;
		padding-right: 20px;
	}
	.playground-split-right {
		border-bottom: solid 3px blue;
		padding-left: 20px;
	}
	.playground-button {
		font-family: Arial, Helvetica, sans-serif;
		margin-top: 3px;
		margin-bottom: 4px;
	}
	.results-box {
		border: dashed 1px black;
		border-radius: 3px;
		margin: 7px;
	}
	.control-box {
		border-radius: 8px;
		background-color: rgb(178, 226, 238);
		border: solid 1px rgb(6, 4, 99);
		padding: 11px;
		padding-left: 30px;
		padding-right: 30px;
		font-size: 9pt;
		margin: 15px;
	}
	.playground-box {
		overflow-y: auto;
		border-radius: 8px;
		background-color: rgb(245, 226, 184);
		border: solid 1px rgb(6, 4, 99);
		padding: 11px;
		padding-left: 30px;
		padding-right: 30px;
		font-size: 9pt;
		margin: 15px;
	}
	.scroll-panel-parent {
		display: flex;
		height: 100%;
		flex-direction: column;
	}
	.scroll-panel {
		flex: 1 1 auto;
		min-height: 0;
		overflow-y: auto;
	}
	.container-crop {
		height: calc(100vh - 125px);
	}
</style>

<template>
	<div class="container-fluid container-crop text-default mt-4 mb-4">
		<div class="row mb-3">
			<div class="col text-center">
				<h3>Memory Cache Statistics</h3>
				<h6>
					Estimate of cache size is not available - cache size is not
					implemented.
				</h6>
			</div>
		</div>

		<div class="row h-100">
			<div class="col-4 scroll-panel-parent border-end">
				<div class="scroll-panel">
					<StatsComponent
						v-for="apiServer in apiServers"
						:key="apiServer.serverName"
						:ServerName="apiServer.serverName"
						:ServerHostname="apiServer.serverHostname"
						:CacheStatistics="stats.find(
							(x:ICacheStatistics) => x.apiServerName === apiServer.serverName
						)"
					>
					</StatsComponent>
				</div>
			</div>
			<div class="col scroll-panel-parent">
				<div class="scroll-panel">
				<div class="row control-box">
					<div class="row row-title mb-2">Control</div>
					<div class="col-2 control-title">Bust Cache</div>
					<div class="col">
						<div class="row">
							<div class="col">Clear Item Type</div>
							<div class="col">
								<Combo
									id="cmbBustItemType"
									:optionList="bustTypes"
									v-model:selected="prodBustTypeSelected"
								>
								</Combo>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col">Bust All</div>
							<div class="col text-end">
								<Checkbox v-model:modelValue="prodBustTypeAll"
									>All Types</Checkbox
								>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col d-inline text-end">
								<ChoiceButton
									@click="performCacheBust(false)"
									:disabled="bustCacheInProgress"
									:size="ButtonDisplaySize.Smaller"
									>Bust Cache Items - Localhost {{}}
								</ChoiceButton>
								<ChoiceButton
									@click="performCacheBust(true)"
									:disabled="bustCacheInProgress"
									:size="ButtonDisplaySize.Smaller"
									>Bust Cache Items - All Api Servers
								</ChoiceButton>
							</div>
						</div>
						<div class="row mt-2">
							<div>Results: {{ prodBustResults }}</div>
						</div>
					</div>
				</div>

				<div class="row mt-2 playground-box">
					<div class="row row-title">Playground</div>
					<div class="col">
						<div class="row playground-row">
							<div class="col-6 playground-split-left d-flex flex-column">
								<div class="control-title d-flex">
									Perform UserName to Security Name Lookup
								</div>
								<div class="row results-box">
									<div>Results: {{ usernameCacheResults }}</div>
								</div>
								<div class="flex-grow-1"></div>

								<div
									class="row playground-button d-flex mt-auto justify-content-end"
								>
									<ChoiceButton
										:disabled="usernameCacheInProgress"
										:size="ButtonDisplaySize.Smaller"
										:width="200"
										@click="playgroundUsernameCache()"
										>Cache Username Lookup
									</ChoiceButton>
								</div>
							</div>
							<div class="col-6 playground-split-right">
								<div class="col-6 control-title">Perform Window Build</div>
								<div class="col">
									<div class="row">
										<div class="col">Menu Type</div>
										<div class="col">
											<Combo
												id="cmbExecuteMenuType"
												:optionList="executeMenuTypes"
												v-model:selected="executeWindowSelected"
											>
											</Combo>
										</div>
									</div>
									<div class="row mt-2">
										<div class="col">Execute Count (1-200)</div>
										<div class="col">
											<IntegerInput
												v-model:numberValue="executeCount"
												:startingRange="1"
												:endingRange="200"
												:errorDisplay="true"
											></IntegerInput>
										</div>
									</div>
									<div class="row results-box">
										<div>Results: {{ executeWindowResults }}</div>
									</div>
									<div
										class="row playground-button justify-content-end mt-auto"
									>
										<ChoiceButton
											@click="playgroundWindowExecute()"
											:size="ButtonDisplaySize.Smaller"
											:width="200"
											:disabled="executeWindowInProgress"
											>Execute Window Build
										</ChoiceButton>
									</div>
								</div>
							</div>
						</div>
						<div class="row playground-row overflow-auto">
							<div class="col-6 playground-split-left">
								<div class="col control-title">View Current Cache Tokens</div>
								<div class="col">
									<div class="row results-box">
										<div>Results: {{ tokenResults }}</div>
									</div>
									<div class="row playground-button justify-content-end">
										<ChoiceButton
											@click="playgroundCacheTokenLookup()"
											:size="ButtonDisplaySize.Smaller"
											:width="200"
											:disabled="tokenInProgress"
											>View Tokens
										</ChoiceButton>
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="col control-title">Execute Database Name Lookup Test</div>
								<div>This test retrieves a list of all databases (from global), initiates a CacheServer.GetOrCreate 
									to retrieve the database key from the company table - repeats it (first time should not be cached, 2nd time should be).
									Finally, it compares the data and returns the results (with timing).</div>
								<div class="col">
									<div class="row results-box">
										<div id="divDatabaseLookupTestResults">Results: </div>
									</div>
									<div class="row playground-button justify-content-end">
										<ChoiceButton
											@click="databaseNameLookupTest()"
											:size="ButtonDisplaySize.Smaller"
											:width="200"
											:disabled="databaseNameLookupInProgress"
											>Execute Test
										</ChoiceButton>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { onMounted, ref } from "vue";
	import { ICacheStatistics } from "./ICacheStatistics";
	import { CacheService } from "../../lib/Api/CacheService";
	import ChoiceButton from "../../components/Buttons/ChoiceButton.vue";
	import { TestingService } from "../../lib/Api/TestingService";
	import Combo from "../../components/Combo.vue";
	import { ButtonDisplaySize, DisplayStyle } from "../../Enums/UiEnums";
	import IntegerInput from "../../components/IntegerInput.vue";
	import Checkbox from "../../components/Inputs/Checkbox.vue";
	import { IApiServer } from "./IApiServer";
	import StatsComponent from "./StatsComponent.vue";

	// servers
	const apiServers = ref<IApiServer[]>([]);
	const currentApiServer = ref<IApiServer>();

	// statistics
	const stats = ref<ICacheStatistics[]>([]);

	// production cache bust
	const prodBustTypeSelected = ref<string | number>("");
	const prodBustTypeAll = ref<boolean>(false);
	const prodBustResults = ref<string | undefined>("");
	const prodBustInProgress = ref<boolean>(false);

	// playground cache bust
	const bustTypes = ref<Array<any>>([]);
	const bustTypeSelected = ref<string | number>("");
	const bustCacheResults = ref<string | undefined>("");
	const bustCacheInProgress = ref<boolean>(false);

	// execute username lookup
	const usernameCacheResults = ref<string | undefined>("");
	const usernameCacheInProgress = ref<boolean>(false);

	// cache token lookup
	const tokenResults = ref<string[]>();
	const tokenInProgress = ref<boolean>(false);

	// database lookup test
	const databaseLookupTestResults = ref<string | undefined>("");
	const databaseNameLookupInProgress = ref<boolean>(false);

	// execute window results
	const executeCount = ref<number>(100);
	const executeWindowResults = ref<string | undefined>("");
	const executeWindowInProgress = ref<boolean>(false);
	const executeWindowSelected = ref<string | number>("");
	const executeMenuTypes: Array<any> = [
		{ value: "Global Administration", description: "Global Administration" },
		{ value: "Report", description: "Report" },
		{ value: "Setup", description: "Setup" },
	];

	onMounted(async () => {
		await UpdateStatistics();
		await LoadData();
		setInterval(UpdateStatistics, 1000 * 10);
	});

	async function UpdateStatistics() {
		await CacheService.GetAllStatistics().then((result) => {
			if (!result) {
				stats.value = [];
				return;
			}

			stats.value = result;
		});

		await CacheService.GetApiServers().then((result) => {
			if (!result) {
				apiServers.value = [];
				return;
			}

			apiServers.value = result;
		});

		await CacheService.GetCurrentApiServer().then((result) => {
			if (!result) {
				currentApiServer.value = undefined;
				return;
			}

			currentApiServer.value = result;
		});
	}

	async function LoadData() {
		await TestingService.GetCacheBustTypes().then((result) => {
			if (!result) {
				bustTypes.value = [];
				return;
			}

			bustTypes.value = result.map((x) => ({
				value: x,
				description: x,
			}));
		});

		await CacheService.GetApiServers().then((result) => {
			if (!result) {
				apiServers.value = [];
				return;
			}

			apiServers.value = result;
		});

		await CacheService.GetCurrentApiServer().then((result) => {
			if (!result) {
				currentApiServer.value = undefined;
				return;
			}

			currentApiServer.value = result;
		});
	}

	async function performCacheBust(allServers: boolean) {
		if (!prodBustTypeSelected.value && !prodBustTypeAll.value) {
			alert("Unable to bust cache - select a value type or 'all'.");
			return;
		}

		prodBustInProgress.value = true;
		await CacheService.BustCacheType(
			allServers,
			prodBustTypeAll.value,
			prodBustTypeSelected.value ?? ""
		)
			.then((result) => {
				prodBustResults.value = `${new Date().toLocaleTimeString()}: ${
					JSON.stringify(result) ?? "Null result."
				}`;
			})
			.catch((error) => {
				prodBustResults.value = `${new Date().toLocaleTimeString()}: ${error}`;
			});

		prodBustInProgress.value = false;

		//UpdateStatistics();
	}

	async function playgroundUsernameCache() {
		usernameCacheInProgress.value = true;
		await TestingService.CacheAllUsersTest().then((result) => {
			usernameCacheResults.value = `${new Date().toLocaleTimeString()}: ${result}`;
		});
		usernameCacheInProgress.value = false;

		//UpdateStatistics();
	}

	async function playgroundCacheTokenLookup() {
		tokenInProgress.value = true;

		await CacheService.GetCacheTokens().then((result) => {
			tokenResults.value = result;
		});

		tokenInProgress.value = false;
	}

	async function databaseNameLookupTest() {
		databaseNameLookupInProgress.value = true;

		await TestingService.CacheTestVerifyAllDatabases().then((result) => {
			databaseLookupTestResults.value = result ?? "No results returned -- likely an error.";

			// this one needs a little extra
			const resultDiv = "divDatabaseLookupTestResults";
			const ele = document.getElementById(resultDiv);
			if(ele) {
				ele.innerHTML = databaseLookupTestResults.value;
			}
		});

		databaseNameLookupInProgress.value = false;
	}

	async function playgroundWindowExecute() {
		if (!executeWindowSelected.value) {
			alert("Select a menu type for lookup.");
			return;
		}

		executeWindowInProgress.value = true;
		await TestingService.ExecuteWindowBuild(
			executeWindowSelected.value,
			executeCount.value
		).then((result) => {
			executeWindowResults.value = `${new Date().toLocaleTimeString()}: ${result}`;
		});

		//UpdateStatistics();
		executeWindowInProgress.value = false;
	}
</script>
